import { authTypes } from "../actionTypes/authTypes";
import * as Requests from "../../services";
import { setToStorage } from "../../utils/storageController";
import makeActionCreator from "./makeActionCreator";



export const loader = makeActionCreator(authTypes.LOADER, "isLoading");

export const loginStart = makeActionCreator(
  authTypes.LOGIN_DETAILS,
  "payload"
);

export const isSuccessLogin = makeActionCreator(
  authTypes.LOGIN_SUCCESS,
  "isSucess",
  "isToken"
);

export const isFailureLogin = makeActionCreator(
  authTypes.LOGIN_FAILURE,
  "isFailure"
);

// Registration

export const RegisterStart = makeActionCreator(
  authTypes.REGISTER_DETAILS,
  "payload"
);

export const isSuccessRegister = makeActionCreator(
  authTypes.REGISTER_SUCCESS,
  "isSucess"
);

export const isFailureRegister = makeActionCreator(
  authTypes.REGISTER_FAILURE,
  "isFailure"
);

//////////////////////////////////  LOGIN USER ///////////////////////////////////////////

export const loginAction = (payload) => {
  return async (dispatch) => {
    dispatch(loader(true));
    try {
      const response = await Requests.loginCall(payload);
      const { token } = response.data;
      setToStorage("token", token);
      if (response.data) {
          dispatch(isSuccessLogin(true, token));
          return { status: true, message: response?.data?.message };
      }
      dispatch(isFailureLogin(true));
    } catch (err) {
      dispatch(isFailureLogin(true));
      return { status: false, message: err?.response?.data?.error };
    }
  };
};

//////////////////////////////////  STORE USER ///////////////////////////////////////////

export const loginStoreAction = (payload) => {
  return async (dispatch) => {
    dispatch(loader(true));
    try {
      const response = await Requests.loginStoreCall(payload);
      const { token } = response.data;
      setToStorage("token", token);
      if (response.data) {
          dispatch(isSuccessLogin(true, token));
          return { status: true, message: response?.data?.message };
      }
      dispatch(isFailureLogin(true));
    } catch (err) {
      dispatch(isFailureLogin(true));
      return { status: false, message: err?.response?.data?.error };
    }
  };
};


//////////////////////////////////  REGISTER USER ///////////////////////////////////////////
export const registerAction = (payload) => {
  return async (dispatch) => {
    dispatch(loader(true));
    try {
      const response = await Requests.registerCall(payload);
      if (response.data) {
        dispatch(isSuccessRegister(true));
        console.log(response)
        return { status: true, message: response?.data?.message };
      }
    } catch (err) {
      dispatch(isFailureRegister(true));
      return { status: false, message: err?.response?.data?.error };
    }
  };
};

//////////////////////////////////  REGISTER USER STORE ///////////////////////////////////////////
export const registerStoreAction = (payload) => {
  return async (dispatch) => {
    dispatch(loader(true));
    try {
      const response = await Requests.createStoreCall(payload);
      if (response.data) {
        dispatch(isSuccessRegister(true));
        return { status: true, message: response?.data?.message };
      }
    } catch (err) {
      dispatch(isFailureRegister(true));
      return { status: false, message: err?.response?.data?.error };
    }
  };
};


//Setup Config/headers and tokens
export const tokenConfig = (getState) => {
  //Get token from localstorage
  const token = getState().authe.token;

  //Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  //IF token, add to headers
  if (token) {
    config.headers["x-access-token"] = token;
    // console.log("oppppppppppppppppppps",token);
  }
  return config;
};
